<template lang="pug">
  section.section
    .container
      .columns
      .card
          .card-content 
            .columns
              .column.is-2
                label.label Fecha de reporte:
                  .field
                    .control
                      flat-pickr(
                        v-model='fechaReporte'
                        :config="config"
                        class="input"
                      )
              .column.is-2
                label.label Esfera:
                  .field
                    .control
                      .select.is-dark
                        select(v-model="selectEsfera")
                          option(:value="null") Seleccione una opcion
                          option(v-for="esfera in esferasList" :key="esfera.value" :value="esfera.value" v-text="esfera.label")           
              .column.is-1.button-bottom
                button.button.is-black.is-rounded.is-small.mt-30.is-top(@click="descargarReporte" :disabled="selectEsfera == null")
                    i.fas.fa-print 
                | &nbsp
      .columns.is-multiline.mt-30
        card_Esfera(v-for="esf in esferas" :esfera="esf" :key="esf.id")
</template>


<script>
  import card_Esfera from '@/components/estaciones_Componentes/layouts/card_Esfera.vue'
  import NotificacionConst from '@/components/shared/NotificacionConst.vue'
  import sca_irgeServices from '@/services/sca/irge.js'
  
  import moment from 'moment'
import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'
import { Spanish } from "flatpickr/dist/l10n/es.js"

  export default {
    name: 'Esferas_IRGE',
    components: { card_Esfera, NotificacionConst,flatPickr },
    props: {
      activo: {
        type: Boolean,
        default: false
      },
    },
    data() {
      return {
        refresh: null,
        esferas: [],
        activarData: this.activo,
        fechaReporte: moment().format('YYYY-MM-DD'),
        config: {
          wrap: true, // set wrap to true only when using 'input-group'
          altFormat: 'Y-m-d',
          altInput: true,
          dateFormat: 'Y-m-d',
          locale: Spanish, // locale for this instance only          
        },
        selectEsfera: null,
        esferasList:[
          {label:'TE-301A',value:'TE-301A'},
          {label:'TE-301B',value:'TE-301B'}
        ]
      }
    },
    watch: {
      activo (active) {
        console.log(active)
        this.activarData = active 
        if (active) {
          this.iniciarComponente()
        } else {
          clearInterval(this.refresh)
        }
      }
    },
    methods: {
      descargarReporte(){
      const currentUrl = window.location.hostname
        let link = ''
        if (currentUrl === '10.122.40.189') {
          link = `http://${currentUrl}//servidores/reportes/monitoreo/esferasIrge.php?fecha=${this.fechaReporte}&esfera=${this.selectEsfera}`
        }
        else {
          link = `https://${currentUrl}//servidores/reportes/monitoreo/esferasIrge.php?fecha=${this.fechaReporte}&esfera=${this.selectEsfera}`
        }
       open(link, '_blank')
    },
      obtenerDatosEsferas () {
        sca_irgeServices.getEsferas()
          .then(res => {
            this.esferas = res
          })
      },
      iniciarComponente () {
        this.refresh = setInterval(() => {
          if (this.activarData) {
            this.obtenerDatosEsferas()
          } else {
            clearInterval(this.refresh)
          }
        }, 5000)
      },
    },
    beforeDestroy() {
      clearInterval(this.refresh)
    },
    created () {
      this.obtenerDatosEsferas()
      this.iniciarComponente()
    },
  }
</script>

<style lang="scss" scoped>
.mt-30{
    margin-top: 30px !important;
  }
</style>


// WEBPACK FOOTER //
// src/components/estaciones_Componentes/Esferas_IRGE.vue